var exports = {
  "kL": "xe533113f--7fdc8c--container",
  "DD": "xe533113f--7fdc8c--title",
  "h_": "xe533113f--7fdc8c--description",
};

module.exports = exports;
